import moment from 'moment';
import axios from   'axios';
import { email } from 'vuelidate/lib/validators';

export const formatDate = (date) => {
    if (date) {
        return moment(String(date), 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
};

export const formatDateToDisplay = (date) => {
    if (date) {
        return moment(String(date), 'YYYY-MM-DD').format('DD-MM-YYYY');
    }
};

export const formatDateToDisplayWithTime = (date) => {
    if (date) {
        return moment(String(date), 'YYYY-MM-DD H:mm').format('DD-MM-YYYY H:mm');
    }
};

export const trimSpaces = (value) => {
    return value.replace(/ /g,'');
};

export const convertDocuments = async (reasonDocuments) => {
    let result = [];
    for (let exemptionDocument of reasonDocuments) {
        result.push({
            typeCode: exemptionDocument.typeCode,
            content: await fileToBase64(exemptionDocument.content)
        });
    }

    return result;
};

export const decodeDocuments = async (reasonDocuments) => {
    const result = [];

    for (let exemptionDocument of reasonDocuments) {
        result.push(await decodeDocument(exemptionDocument));
    }

    return result;
};

export const decodeDocument = async (exemptionDocument) => {
    let array = exemptionDocument.content.split(','),
        mimeType = array[0].match(/:(.*?);/)[1],
        binaryString = atob(array[1]),
        length = binaryString.length,
        u8arr = new Uint8Array(length);

    while (length--) {
        u8arr[length] = binaryString.charCodeAt(length);
    }

    return {
        typeCode: exemptionDocument.typeCode,
        content: new File(
            [u8arr],
            matchDocumentTypeToFilename(exemptionDocument.typeCode),
            { type: mimeType }
        )
    }
};

export const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        if (!file || file.size === 0) {
            reject(new Error('Le fichier est vide.'));

            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
};

export const forceFileDownload = async (downloadLink, filename, mimeType = 'application/pdf', config = {}, timeout = 30000) => {
    const res = await axios.get(downloadLink, {
        responseType: 'blob',
        timeout,
        ...config
    });

    let download;
    if (filename) {
        download = filename;
    } else {
        const fileNameMatch = res.headers['content-disposition'].match(/filename="?([^"]+)"?/)
        if (fileNameMatch && fileNameMatch.length > 1) {
            download = fileNameMatch[1]
        }
    }

    let blob = new Blob([res.data], { 'type': mimeType });
    const link = document.createElement('a');

    link.href = window.URL.createObjectURL(blob);
    link.download = download;
    document.body.appendChild(link);

    link.click();
    link.remove();
};

export const downloadFile = async (exemptionDocument) => {
    const blob = new Blob(
        [exemptionDocument.content],
        { type: exemptionDocument.content.type }
    );
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = exemptionDocument.content.name;
    link.click();
    URL.revokeObjectURL(link.href);
};

export const buildPhoneNumberMaskedInput = (phoneNumber) => {
    let result = `+33 ${ phoneNumber[3] }`;
    for (let i = 4; i <= 10; i += 2) {
        result += ` ${ phoneNumber.substr(i, 2) }`;
    }

    return result;
};

export const matchDocumentTypeToFilename = (documentTypeCode) => {
    switch (documentTypeCode) {
        case 'SD0':
            return 'Exemption';
        case 'SD1':
            return 'ContratTravail';
        case 'SD2':
            return 'ContratTravailOuConventionStage';
        case 'SD3':
            return 'AttestationAssuranceSante';
        case 'SD4':
            return 'AttestationComplementaireSanteSolidaire'
        case 'SD5':
            return 'AttestationSanteCollectif';
        case 'SD6':
            return 'AttestationSanteResponsable';
        case 'SD7':
            return 'AttestationSanteIndividuel';
        case 'SD8':
            return 'DeclarationHonneur';
        case 'PC':
            return 'ConditionsParticulieres';
        case 'COI':
            return 'CopieNoticeInformation';
        case 'PCF':
            return 'ConditionsParticulieresSurcomplementaire';
        case 'COIF':
            return 'CopieNoticeInformationSurcomplementaire';
        case 'DSOSD':
            return 'FeuilleEmargementDocument';
    }
}

export const filterRenewReasons = (exemption, reasons) => {
    if (!exemption || !exemption.previousReason) {
        return reasons;
    }

    return reasons.filter((reason) => {
        if (reason.code !== exemption.previousReason.code) {
            return true;
        }
        return reason.canBeRenewed === true;
    });
};

export const isSupportingDocumentExpiredParticularCase = (exemption) => {
    if (!exemption || !exemption.previousReason) {
        return false;
    }

    return ['cd4', 'cdf6', 'cdp4'].includes(exemption.previousReason.code);
};

export const filterObjectsArrayByProperties = (array, propertyNames) => {
    const result = [];
    const map = new Map();

    for (const item of array) {
        for (const propertyName of propertyNames) {
            if(item[propertyName] && !map.has(item[propertyName])){
                map.set(item[propertyName], true);
                result.push(item);
            }
        }
    }

    return result;
};

export const isEmpty = (object) => {
    return Object.keys(object).length === 0;
};

export const isObjectPropertyExist = (object, propertyName) => {
    return null !== object
        && Object.prototype.hasOwnProperty.call(object, propertyName);
};

export const uniqueValidEmail = (value, index, self) => {
    return self.indexOf(value) === index && email(value) && value !== undefined;
};

const EXEMPTION_STATUSES = {
    draft: 'Brouillon',
    to_finalise: 'À finaliser',
    to_validate: 'À valider',
    to_renew: 'À renouveler',
    to_abort: 'À abandonner',
    validated: 'Validée',
    rejected: 'Rejetée',
    aborted: 'Annulée',
    archived: 'Archivée',
    terminated_early: 'Fin anticipée',
    renewal_declined: 'Renoncée',
};

export const getExemptionStatusLabel = (status) => EXEMPTION_STATUSES[status] ?? status;

export const getExemptionStatuses = () => EXEMPTION_STATUSES;
